import { GraficaEstadisticaMedidorComponent } from './grafica-estadistica-medidor/grafica-estadistica-medidor.component';
import { MedidoresService } from './../../../../services/medidores.service';
import { MapaService } from './../../../../services/mapa.service';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { ReporteMedidores } from './../../../../../../_entities/medidores/ReporteMedidores';
import { Component, Inject, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

const MESES = [
	{ valor: 0, etiqueta: 'Enero', dias: 31 },
	{ valor: 1, etiqueta: 'Febrero', dias: 29 },
	{ valor: 2, etiqueta: 'Marzo', dias: 31 },
	{ valor: 3, etiqueta: 'Abril', dias: 30 },
	{ valor: 4, etiqueta: 'Mayo', dias: 31 },
	{ valor: 5, etiqueta: 'Junio', dias: 30 },
	{ valor: 6, etiqueta: 'Julio', dias: 31 },
	{ valor: 7, etiqueta: 'Agosto', dias: 31 },
	{ valor: 8, etiqueta: 'Septiembre', dias: 30 },
	{ valor: 9, etiqueta: 'Octubre', dias: 31 },
	{ valor: 10, etiqueta: 'Noviembre', dias: 30 },
	{ valor: 11, etiqueta: 'Diciembre', dias: 31 }
]


@Component({
	selector: 'kt-historico-posiciones-medidor',
	templateUrl: './historico-posiciones-medidor.component.html',
	styleUrls: ['./historico-posiciones-medidor.component.scss']
})
export class HistoricoPosicionesMedidorComponent implements OnInit {
	public currentFilter: any;
	public showFilterRow: boolean;
	public disabledButtonGraficas: boolean = true;
	public fechaInicio;
	public fechaFin;
	public descripcion;
	public dataSourceReportePosiciones: ReporteMedidores[]
	public datosReporte = [];
	public isDisabled: boolean = true;
	public showGrafica: boolean = false;
	public verGasto: boolean = false;
	public verTotalizador: boolean = false;
	public verGeneral: boolean = false;
	public loadingVisible: boolean = false;
	public chart_visualRange;
	public gastoPromedio;

	public gastoInicial;
	public fechaInicial;

	public gastoFinal;
	public fechaFinal

	public  totalizadorIncial;
	public totalizadorFinal;

	public mesValue = new Date().getMonth();
	public anio = new Date().getFullYear();
	public mesActual;
	public mesAnterior;

	public medidorMes;
	public mediorAño;

	public visualRange = {};

	longtabs = [
		{ titulo: "Gasto" },
		{ titulo: "Totalizador"},
		{ titulo: "General" }
	];

	constructor(public medidoresService: MedidoresService,
		public dialogRef: MatDialogRef<HistoricoPosicionesMedidorComponent>,
		private toastService: ToastrService,
		public dialog: MatDialog,
		public mapaService: MapaService,
		private datepipe: DatePipe,
		@Inject(MAT_DIALOG_DATA) public data: any) {
		this.showFilterRow = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.descripcion = this.data;
		this.mesActual = MESES.find(mes => this.mesValue === mes.valor);
		this.mesAnterior = MESES.find(mes => this.mesValue - 1 === mes.valor);
	}

	customizeEtiqueta(arg) {
		return arg.valueText + ' m3';
	}

	reportePosicion(fechaInicio, fechaFin, tipoConsulta) {
		this.showGrafica = false;
		this.loadingVisible = true;

		const fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
		const fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");

		const fecha1 = moment(this.datepipe.transform(fechaInicial, 'yyyy-MM-dd'));
		const fecha2 = moment(this.datepipe.transform(fechaFinal, 'yyyy-MM-dd'))

		const difereciaDias = fecha2.diff(fecha1, 'days');

		if(difereciaDias < 3) {
			tipoConsulta = 'dia';
		} else {
			tipoConsulta = 'mes';
		}

		this.medidoresService.obtenerReportePosicionesMedidores(this.data.imei, fechaInicial, fechaFinal).pipe(
			finalize(
				() => { this.loadingVisible = false; }
			)
		).subscribe(
			(medidores: ReporteMedidores[]) => {
				if (medidores.length > 0) {
					medidores.map(medidor => {
						if (medidor.gasto == "NaN") {
							medidor.gasto = 0;
						}

						if (medidor.totalizador == "NaN") {
							medidor.totalizador = 0;
						}
						medidor.fechaHora = this.datepipe.transform(medidor.fechaHora, 'yyyy-MM-dd HH:mm');
					});

					this.fechaInicial = fechaInicial;
					this.fechaFinal = fechaFinal;

					switch (tipoConsulta) {
						case 'rango':
							this.dataSourceReportePosiciones = medidores;
							this.obtenerGastoPromedio(this.dataSourceReportePosiciones);

							this.gastoInicial = this.dataSourceReportePosiciones[0].gasto;
							this.gastoFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length -1].gasto;

							this.totalizadorIncial = this.dataSourceReportePosiciones[0].totalizador;
							this.totalizadorFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length - 1].totalizador;

							this.showGrafica = true;
							break;
						case 'dia':
							medidores.map(medidor => {
								medidor.fechaHora = this.datepipe.transform(medidor.fechaHora, 'HH:00:00');
							});
							this.dataSourceReportePosiciones = this.sumarGastoDia(medidores);
							this.obtenerGastoPromedio(this.dataSourceReportePosiciones);
							this.gastoInicial = this.dataSourceReportePosiciones[0].gasto;
							this.gastoFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length -1].gasto;

							this.totalizadorIncial = this.dataSourceReportePosiciones[0].totalizador;
							this.totalizadorFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length - 1].totalizador;

							this.showGrafica = true;
							break;
						case 'mes':
							medidores.map(medidor => {
								medidor.fechaHora = this.datepipe.transform(medidor.fechaHora, 'yyyy-MM-dd');
							});
							this.dataSourceReportePosiciones = this.sumarGastoDia(medidores);
							this.obtenerGastoPromedio(this.dataSourceReportePosiciones);
							this.gastoInicial = this.dataSourceReportePosiciones[0].gasto;
							this.gastoFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length -1].gasto;

							this.totalizadorIncial = this.dataSourceReportePosiciones[0].totalizador;
							this.totalizadorFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length - 1].totalizador;

							this.showGrafica = true;
							break;
						case 'año':
							medidores.map(medidor => {
								medidor.fechaHora = this.datepipe.transform(medidor.fechaHora, 'yyyy-MM-dd');
							});
							let gastoDiario = this.sumarGastoDia(medidores);
							this.sumarGastoSemana(gastoDiario);
							this.obtenerGastoPromedio(this.dataSourceReportePosiciones);
							this.gastoInicial = this.dataSourceReportePosiciones[0].gasto;
							this.gastoFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length -1].gasto;

							this.totalizadorIncial = this.dataSourceReportePosiciones[0].totalizador;
							this.totalizadorFinal = this.dataSourceReportePosiciones[this.dataSourceReportePosiciones.length - 1].totalizador;

							this.showGrafica = true;
							break;
					}
					this.visualRange = {
						startValue: this.dataSourceReportePosiciones[0].fechaHora,
						endValue: this.dataSourceReportePosiciones[2].fechaHora
					};
				} else {
					this.toastService.info('Sin datos disponibles');
				}
			}
		);
	}


	//Obtenemos el consumo diario del medidor
	sumarGastoDia(datos) {
		let nuevoObjeto = {}
		let gastoTotal;
		let totalizadorTotal;
		let nuevaRespuesta = [];
		//Recorremos el arreglo
		datos.forEach(x => {
			//Si la fecha no existe en nuevoObjeto, entonces la creamos e inicializamos el arreglo de datos.
			if (!nuevoObjeto.hasOwnProperty(x.fechaHora)) {
				nuevoObjeto[x.fechaHora] = {
					datos: []
				}
			} else {
				//Agregamos los datos al arreglo datos.
				nuevoObjeto[x.fechaHora].datos.push({
					fechaHora: x.fechaHora,
					gasto: x.gasto,
					totalizador: x.totalizador
				})
			}
		})

		const keys = Object.keys(nuevoObjeto)

		keys.forEach(key => {
			gastoTotal = 0;
			totalizadorTotal = 0;
			nuevoObjeto[key].datos.forEach(dato => {
				gastoTotal = gastoTotal + dato.gasto;
				totalizadorTotal = totalizadorTotal + dato.totalizador;
			});

			let form = {
				fechaHora: key,
				gasto: Number(gastoTotal.toFixed(2)),
				totalizador: Number(totalizadorTotal.toFixed(2))
			}

			nuevaRespuesta.push(form)
		});
		return nuevaRespuesta
	}

	obtenerGastoPromedio(datos) {
		let gastoTotal = 0;

		datos.forEach(dato => {
			gastoTotal = gastoTotal + dato.gasto;
		});

		this.gastoPromedio = (gastoTotal / (datos.length)).toFixed(4);
	}

	sumarGastoSemana(gastoDiario) {
		let nuevaRespuesta;
		let gastoTotal = 0;



		if(gastoDiario.length > 7) {
		} else {
			gastoDiario.forEach(dato => {
				gastoTotal = gastoTotal + dato.gasto
			});

			let form = {
				fechaHora: 'semana 1',
				gasto: Number(gastoTotal.toFixed(2))
			}
			nuevaRespuesta.push(form);
		}
		return nuevaRespuesta
	}

	obtenerReporteHoy() {
		const fechaInicio = this.datepipe.transform(new Date(), 'yyyy-MM-dd 00:00:00');
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.reportePosicion(fechaInicio, fechaFinal, 'hoy');
	}

	obtenerReporteMes() {
		const fechaInicio = this.datepipe.transform(new Date(), 'yyyy-MM-01 00:00:00');
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.reportePosicion(fechaInicio, fechaFinal, 'mes');
	}

	obtenerReporteMesAnterior() {
		const fecha = new Date();
		const mesValue = fecha.getMonth() - 1;

		fecha.setMonth(mesValue);

		const mes = MESES.find(mes => mes.valor === mesValue);
		const fechaInicio = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-01 00:00:00`;
		const fechaFinal = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-${mes.dias} 23:59:59`;

		this.reportePosicion(fechaInicio, fechaFinal, 'mes');

	}

	obtenerReporteTresMeses() {
		const fecha = new Date();
		const mesValue = fecha.getMonth() - 3;

		fecha.setMonth(mesValue);

		const fechaInicio = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-01 00:00:00`;
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.reportePosicion(fechaInicio, fechaFinal, 'mes');

	}

	obteneReporteAnio() {
		const fechaInicio = this.datepipe.transform(new Date(), 'yyyy-01-01 00:00:00');
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.reportePosicion(fechaInicio, fechaFinal, 'año');
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	selectTab(e){
		if(e.name === "changedProperty") {
			console.log('alv');
		}
	}

	verGraficas() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "58%";
		//dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = this.dataSourceReportePosiciones
		this.dialog.open(GraficaEstadisticaMedidorComponent, dialogConfig);
		this.dialogRef.close();
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
